(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["movesmart-payment-dialog"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ms-dialog-root')) {
    customElements.define('ms-dialog-root', class extends HTMLElement {
      connectedCallback() {
        if (this.controller || typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal) return;
        this.controller = new AbortController();
        this.boundDialogs = new WeakSet();
        document.addEventListener('click', event => {
          const trigger = event.target.closest('[data-msp-open]');
          if (!trigger || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const dialog = document.getElementById(trigger.dataset.mspOpen);
          if (this.openDialog(dialog, trigger)) event.preventDefault();
        }, { signal: this.controller.signal, capture: true });
        window.addEventListener('hashchange', () => {
          if (this.activeDialog?.mspHash && location.hash !== '#' + this.activeDialog.id) this.activeDialog.close();
          this.openFromHash();
        }, { signal: this.controller.signal });
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.openFromHash(), { once: true, signal: this.controller.signal });
        else this.openFromHash();
      }
      openFromHash() {
        if (location.hash !== '#msp-options-global') return;
        const dialog = this.querySelector('#msp-options-global');
        if (this.openDialog(dialog)) dialog.mspHash = true;
      }
      openDialog(dialog, trigger = null) {
        if (!(dialog instanceof HTMLDialogElement) || dialog.open || this.activeDialog?.open) return false;
        this.bindDialog(dialog);
        try { dialog.showModal(); } catch (_) { return false; }
        this.activeDialog = dialog;
        dialog.mspOpener = trigger;
        dialog.mspHash = location.hash === '#' + dialog.id;
        dialog.mspOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        dialog.querySelectorAll('template[data-msp-media]').forEach(template => template.replaceWith(template.content.cloneNode(true)));
        dialog.querySelector('h2')?.focus({ preventScroll: true });
        return true;
      }
      bindDialog(dialog) {
        if (this.boundDialogs.has(dialog)) return;
        this.boundDialogs.add(dialog);
        const options = { signal: this.controller.signal };
        dialog.querySelector('[data-msp-close]')?.addEventListener('click', () => dialog.close(), options);
        dialog.addEventListener('click', event => {
          const box = dialog.getBoundingClientRect();
          if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
        }, options);
        dialog.addEventListener('close', () => {
          if (dialog.mspOverflow !== undefined) document.documentElement.style.overflow = dialog.mspOverflow;
          delete dialog.mspOverflow;
          if (dialog.mspHash && location.hash === '#' + dialog.id) history.replaceState(history.state, '', location.pathname + location.search);
          delete dialog.mspHash;
          if (dialog.mspOpener?.isConnected) dialog.mspOpener.focus({ preventScroll: true });
          this.activeDialog = null;
        }, options);
        dialog.addEventListener('keydown', event => {
          if (event.key !== 'Tab') return;
          const items = [...dialog.querySelectorAll('button,a[href],summary,input,select,textarea,[tabindex="0"]')].filter(item => !item.disabled && item.getClientRects().length);
          const first = items[0], last = items[items.length - 1];
          if (!first) { event.preventDefault(); return; }
          if (event.shiftKey && (document.activeElement === first || !items.includes(document.activeElement))) {
            event.preventDefault(); last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault(); first.focus();
          }
        }, options);
        dialog.querySelectorAll('.msp__guide').forEach(guide => guide.addEventListener('toggle', () => {
          const template = guide.querySelector('template');
          if (guide.open && template) template.replaceWith(template.content.cloneNode(true));
        }, options));
      }
      disconnectedCallback() {
        const dialog = this.activeDialog;
        if (dialog?.open) {
          const previousOverflow = dialog.mspOverflow || '';
          dialog.close();
          document.documentElement.style.overflow = previousOverflow;
        }
        this.controller?.abort();
        this.controller = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
